import React, { useState, useEffect, useRef } from 'react';

import HeroSection from './components/HeroSection';
import AudioDemoSection from './components/AudioDemoSection';
import EnterpriseSection from './components/EnterpriseSection';
import SignupFooter from './components/SignupFooter';

const SignupPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAFBFF', fontFamily: "'Plus Jakarta Sans', 'DM Sans', sans-serif" }}>
      <HeroSection />
      <AudioDemoSection />
      <EnterpriseSection />
      <SignupFooter />
    </div>
  );
};

export default SignupPage;
